import React from 'react';

import Avatar from 'components/Avatar';

import StatusBox from 'components/StatusBox';
import {KYC_STATUSES_COLORS} from 'ducks/bookings';

import './styles.css';

const AgreementUserInfo = ({agreementUser, status}) => {
  const {
    fullName,
    avatarCropped,
    internalAvatarCropped,
    initials
  } = agreementUser;

  return (
    <div className="AgreementUserInfo">
      <Avatar
        url={internalAvatarCropped || avatarCropped}
        initials={initials}
      />
      <div className="info">
        <div className="name">{fullName}</div>
        <StatusBox color={KYC_STATUSES_COLORS[status]} status={status} />
      </div>
    </div>
  );
};

export default AgreementUserInfo;
